module.exports = __webpack_public_path__ + "img/tree2_down_2021.3685ceb6.gif";